import { render, staticRenderFns } from "./DomainManager.vue?vue&type=template&id=fdc77dda"
import script from "./DomainManager.vue?vue&type=script&lang=js"
export * from "./DomainManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports